const COMPANY = 'COMPANY';
const INDIVIDUAL = 'INDIVIDUAL';

const businessTypes = {
  [COMPANY]: 'company',
  [INDIVIDUAL]: 'individual',
};

export default businessTypes;
